import { InputRow, PageWrapper } from '@components/Dashboard/components'
import type { AccountData } from '@store/reducers/account'
import type React from 'react'

import { Divider } from '../../../../components/Divider'
import type { AccountFormHandler } from '../../types'
import { EmailInput } from '../EmailInput'

interface Props extends React.PropsWithChildren {
  state: AccountData
  onChange: AccountFormHandler
  onChangeEmail: (next: string) => void
}

export const PersonalInfoSection: React.FC<Props> = ({
  state,
  onChange,
  children,
  onChangeEmail,
}) => {
  return (
    <PageWrapper title="Account settings">
      <InputRow
        value={state.firstName}
        title="First name"
        onChange={onChange('firstName')}
      />

      <Divider />

      <InputRow
        value={state.lastName}
        title="Last name"
        onChange={onChange('lastName')}
      />

      <Divider />

      <InputRow
        value={state.companyName}
        title="Company"
        onChange={onChange('companyName')}
      />

      <Divider />

      <EmailInput initial={state.emailAddress} onSubmit={onChangeEmail} />

      <Divider />
      {children}
    </PageWrapper>
  )
}
